<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>PC调拨</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div style="padding: 10px 25px">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="demo-ruleForm"
          >
            <el-form-item prop="toWhere">
              <el-select
                ref="toWhere"
                v-model="form.toWhere"
                placeholder="请选择调拨方向"
                @change="handleToWhere"
              >
                <el-option
                  v-for="(item, key) in to_where_options"
                  :key="key"
                  :label="item"
                  :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!blp_radio_disabled" label="不良品类型:">
              <el-radio-group
                v-model="form.blp_type"
                :disabled="blp_radio_disabled"
              >
                <el-radio
                  v-for="(item, key) in blp_type"
                  :key="item"
                  :label="key"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="!radio_disabled" label="次品等级:">
              <el-radio-group
                v-model="form.the_level"
                :disabled="radio_disabled"
              >
                <el-radio
                  v-for="(item, key) in the_level_options"
                  :key="item"
                  :label="key"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="!radio_disabled" label="问题分类:">
              <el-radio-group
                v-model="form.problem_type"
                :disabled="radio_disabled"
              >
                <el-radio
                  v-for="(item, key) in problem_type_options"
                  :key="item"
                  :label="key"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="qrCode">
              <el-row>
                <el-col :span="6">
                  <el-input
                    ref="qrCode"
                    v-model="form.qrCode"
                    :disabled="
                      !(form.toWhere > 0 &&
                      (form.blp_type > 0 ||
                        (form.the_level > 0 && form.problem_type > 0) ||
                        form.toWhere == 1))
                    "
                    placeholder="请输入dbid(dbid=xxx)"
                    @keyup.enter.native="submit"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loading: false,
      form: {
        toWhere: "",
        the_level: "0",
        problem_type: "0",
        qrCode: "",
        blp_type: "0",
      },
      rules: {
        qrCode: [{ required: true, message: "请输入打标id", trigger: "blur" }],
        toWhere: [
          {
            required: true,
            message: "请选择调拨仓区",
            trigger: "blur",
          },
        ],
      },
      // wave_picking_data: null,
      to_where_options: this.getToWhere(),
      the_level_options: this.getTheLevel(),
      problem_type_options: this.getProblemType(),
      blp_type: this.getBlpType(),
      biao_data: null,
      radio_disabled: true,
      blp_radio_disabled: true,
      msgbox_show: false,
      disable: true,
    };
  },
  created() {
    this.initWebSocket();
    this.$alert("请检查是否链接打印机！", "提示", {
      confirmButtonText: "知道了",
      center: true,
      callback: action => {},
    });
  },
  destroyed: function() {
    //页面销毁时关闭长连接
    this.websocketclose();
  },
  methods: {
    getToWhere() {
      this.$http
        .post("/erp/Common/getStockToWhere", {
          filter: ["无", "库存区", "售后区"],
        })
        .then(res => {
          this.to_where_options = res.data.data;
        });
    },
    getTheLevel() {
      this.$http.post("/erp/Common/getStockTheLevel").then(res => {
        this.the_level_options = res.data.data;
      });
    },
    getProblemType() {
      this.$http.post("/erp/Common/getStockProblemType").then(res => {
        this.problem_type_options = res.data.data;
      });
    },
    getBlpType() {
      this.$http
        .post("/erp/Common/getBlpType", {
          filter: ["错款", "核销", "差异", "退还", "次品(可换)"],
        })
        .then(res => {
          this.blp_type = res.data.data;
        });
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.trans();
        } else {
          return false;
        }
      });
    },
    handleToWhere() {
      if (this.form.toWhere == 5) {
        this.form.blp_type = "0";
        this.radio_disabled = false;
        this.blp_radio_disabled = true;
      } else if (this.form.toWhere == 3) {
        // 切换到退换区时 重置次品等级跟问题类型
        this.form.problem_type = "0";
        this.form.the_level = "0";
        this.radio_disabled = true;
        this.blp_radio_disabled = false;
      } else {
        this.form.blp_type = "0";
        this.form.problem_type = "0";
        this.form.the_level = "0";
        this.radio_disabled = true;
        this.blp_radio_disabled = true;
      }
      //选择仓区让文本框获取焦点
      this.$refs.qrCode.focus();
    },
    trans() {
      // 调拨
      this.$http
        .post("/storage/StockIn/stockTransfers", {
          qrCode: this.form.qrCode,
          toWhere: this.form.toWhere,
          the_level: this.form.the_level,
          problem_type: this.form.problem_type,
          blp_type: this.form.blp_type,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            if (res.data.data?.time) {
              this.$message({
                type: "error",
                message: res.data.msg,
                duration: (res.data.data?.time || 3) * 1000,
              });
            } else {
              this.$message.error(res.data.msg);
            }
            this.closeDialog();
          } else {
            this.$message.success(res.data.msg);
            this.websocketsend(JSON.stringify(res.data.data.print_data));
            this.closeDialog();
          }
        });
    },
    closeDialog() {
      //关闭窗口时重置所有数据
      this.form.qrCode = "";
      this.wave_picking_data = null;
      this.biao_data = null;
      this.$msgbox.close();
      //文本框重新获得焦点
      this.$refs.qrCode.focus();
    },
    //websocket相关
    initWebSocket() {
      //初始化weosocket

      var ishttps = "https:" == document.location.protocol ? true : false;
      if (ishttps) {
        var wsuri = "wss://localhost:13529"; //https wss地址
      } else {
        var wsuri = "ws://localhost:13528"; //ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror(e) {
      //错误
      this.$alert("打印机连接失败", "提示", {
        confirmButtonText: "知道了",
        center: true,
        type: "error",
        callback: action => {
          this.disable = true;
        },
      });
    },
    websocketonmessage(e) {
      var obj = JSON.parse(e.data);
      if (obj.cmd == "print") {
        if (obj.status == "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "重新打印",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.websocketsend(this.transData.print_data);
          });
        } else {
          this.$message.success("打标成功");
        }
      }
    },
    websocketsend(agentData) {
      //数据发送
      this.websock.send(agentData);
    },
    websocketclose(e) {
      //关闭
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/PcTrans.vue